import Vue from 'vue/dist/vue.esm';
import Vuex from "vuex";

import VueYoutube from 'vue-youtube';
import vueVimeoPlayer from 'vue-vimeo-player';
import Vuelidate from 'vuelidate';

import createStore from './store';
import UtilsPlugin from './utils';
import { EventBus } from "./EventBus";

Vue.use(Vuex);
Vue.use(VueYoutube);
Vue.use(vueVimeoPlayer);
Vue.use(Vuelidate);
Vue.use(UtilsPlugin);

const files = require.context('./components/', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

new Vue({
  el: '#app',
  store: createStore(Vuex),
  data() {
    return {
      isOpenAddMenu: false,
      toogleSearchForm: {
        touchScreen: false,
        desktop: false
      },
      classForToogleSearchForm: {
        touchScreen: '',
        desktop: ''
      },
      isMountedComponent: false,
      toogleAboutAccDropDown: false,
      classForAboutAccDropdown: '',
      showSecondaryNavbar: false,
      checkBreakpointTouchScreen: '',
      showFloatingBox: true,
    }
  },
  beforeCreate() {
    EventBus.$on("domIsLoaded", () => {
      this.isMountedComponent = true;
    });
    this.$store.dispatch('assignInitiallizeStore');
  },
  mounted() {
    document.addEventListener('copy', (event) => {
      if (document.getSelection().toString().length <= 50) {
        return;
      }

      const pagelink = `\n\nLearn more at: ${document.location.href}`;
      const selectedText = document.getSelection().toString();
      event.clipboardData.setData('text', `${ selectedText } ${ pagelink }`);
      event.preventDefault();

      if (window?.dataLayer) {
        window.dataLayer.push({
          event: 'copy-text',
          textData: selectedText
        });
      }
    });
    this.checkBreakpointTouchScreen = window.matchMedia('(max-width: 1023px)');
    this.setupFloatingBox();
    window.addEventListener('resize', this.setupFloatingBox);
  },
  methods: {
    toogleAddMenu(e) {
      e.preventDefault();
      this.isOpenAddMenu = !this.isOpenAddMenu;
    },
    openAndCloseSearchForm(e) {
      e.preventDefault();
      if (this.checkBreakpointTouchScreen.matches) {
        this.toogleSearchForm.touchScreen = !this.toogleSearchForm.touchScreen;
        this.classForToogleSearchForm.touchScreen = this.toogleSearchForm.touchScreen ? 'is-active' : 'is-hiding';
      }
      else {
        this.toogleSearchForm.desktop = !this.toogleSearchForm.desktop;
        this.classForToogleSearchForm.desktop = this.toogleSearchForm.desktop ? 'is-active' : 'is-hiding';
      }
    },
    closeSearchForm(){
      if (this.checkBreakpointTouchScreen.matches) {
        this.toogleSearchForm.touchScreen = false;
        this.classForToogleSearchForm.touchScreen = 'is-hiding';
      }
      else {
        this.toogleSearchForm.desktop = false;
        this.classForToogleSearchForm.desktop = 'is-hiding';
      }
    },
    closeSearchFormDesktop() {
      this.toogleSearchForm.desktop = false;
      this.classForToogleSearchForm.desktop = 'is-hiding';
    },
    closeSearchFormTouchScreen() {
      this.toogleSearchForm.touchScreen = false;
      this.classForToogleSearchForm.touchScreen = 'is-hiding';
    },
    closeAddMenu(){
      this.isOpenAddMenu = false;
    },
    openAndCloseAboutAccDropdown(e){
      e.preventDefault();
      this.toogleAboutAccDropDown = !this.toogleAboutAccDropDown;
      this.classForAboutAccDropdown = this.toogleAboutAccDropDown ? 'is-active' : 'is-hiding';
    },
    closeAboutAccDropDown() {
      if (this.toogleAboutAccDropDown) {
        this.toogleAboutAccDropDown = false;
        this.classForAboutAccDropdown = 'is-hidden';
      }
    },
    searchIsDone(e) {
      this.$store.dispatch('assignSearchByTermDone');
    },
    toogleSecondaryNavbar(e) {
      if (!this.showSecondaryNavbar) {
        e.preventDefault();
        this.showSecondaryNavbar = true;
      }
    },
    closeContactBox(e){
      e.preventDefault();
      this.showFloatingBox = !this.showFloatingBox;
    },
    setupFloatingBox() {
      const isMobile = window.matchMedia('(max-width: 768px)');
      this.showFloatingBox = !isMobile.matches;
    }
  }
});
